import { render, staticRenderFns } from "./couponTurn.vue?vue&type=template&id=47ee6fe6&scoped=true&"
import script from "./couponTurn.js?vue&type=script&lang=js&"
export * from "./couponTurn.js?vue&type=script&lang=js&"
import style0 from "./couponTurn.vue?vue&type=style&index=0&id=47ee6fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee6fe6",
  null
  
)

export default component.exports